import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { Spinner } from "react-bootstrap";

import {
  ROUTE_PAYMENT,
  ROUTE_TEACHER,
  ROUTE_STUDENT,
  ROUTE_FINANCIAL_FACTOR_DETAIL,
} from "../../../../../routes";

import { showDangerAlert } from "../../../../../redux/actions/alert/alertActions";

import { paymentStatus } from "../../../../../libs/getConstants";

import ButtonComponent from "../../../../public/button";

import {
  CompanyContainerDetail,
  FinancialTableWrapper,
  FinancialTableBodyRow,
  FinancialTableDetail,
  FinancialTableHeaderRow,
} from "./styledUserFinancialPersonalDetailComponent";
import { StatusFinancialBadge } from "../userFinancialListPersonalComponent/styledUserFinancialListPersonalComponent";

function UserFinancialPersonalDetailComponent({
  financialData,
  runPostCart,
  extensionPackageIsLoading,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id: factorID } = useParams();
  const userRole = useSelector((state) => state.userDetail.userRole);

  const paymentStatusConstants = paymentStatus();

  const userRoleRoute = userRole === "student" ? ROUTE_STUDENT : ROUTE_TEACHER;

  const handleSubmitPersonalPurchase = (e) => {
    e.preventDefault();
    const arraySubmit = [
      {
        grade: null,
        count: 1,
        unitoftime: null,
        salespackage: e.target.id,
      },
    ];

    const data = {
      data: arraySubmit,
      cookieId: null,
    };

    runPostCart(data)
      .then(() => {
        history.push({
          pathname: ROUTE_PAYMENT,
        });
      })
      .catch((error) => {
        dispatch(showDangerAlert(error.response.data.details));
      });
  };

  return (
    <>
      <CompanyContainerDetail className="d-flex justify-content-around">
        <tbody>
          <tr>
            <td>
              <StatusFinancialBadge>
                {paymentStatusConstants[financialData.status]}
              </StatusFinancialBadge>
            </td>
            <td>{financialData?.gross_total?.toLocaleString()} تومان </td>
            <td>
              <ButtonComponent
                isLink={true}
                to={`${userRoleRoute}/${ROUTE_FINANCIAL_FACTOR_DETAIL}/${factorID}`}
                variant="outline-primary factor-btn"
                className="justify-content-center"
              >
                مشاهده فاکتور
              </ButtonComponent>
            </td>
          </tr>
        </tbody>
      </CompanyContainerDetail>

      <FinancialTableWrapper className="pt-2 pb-5">
        <FinancialTableDetail>
          <thead>
            <FinancialTableHeaderRow>
              <th>پایه</th>
              <th>مبلغ </th>
              <th>تمدید</th>
            </FinancialTableHeaderRow>
          </thead>
          <tbody>
            {financialData.invoicedetails_set.map((item, index) => {
              return (
                <FinancialTableBodyRow key={index}>
                  <td>{item.grade.name}</td>
                  <td>{item.unit_price.toLocaleString()}</td>
                  <td>
                    {!financialData.invoicedetails_set[0]?.sales_package
                      ?.is_not_buyable ? (
                      extensionPackageIsLoading ? (
                        <ButtonComponent className="px-5 mt-5 w-100" disabled>
                          <Spinner
                            as="span"
                            animation="border"
                            role="status"
                            aria-hidden="true"
                          />
                        </ButtonComponent>
                      ) : (
                        <ButtonComponent
                          className="btn-custom"
                          id={financialData.invoicedetails_set[0].sales_package.id}
                          onClick={handleSubmitPersonalPurchase}
                        >
                          تمدید سفارش
                        </ButtonComponent>
                      )
                    ) : (
                      <>غیر قابل تمدید</>
                    )}
                  </td>
                </FinancialTableBodyRow>
              );
            })}
          </tbody>
        </FinancialTableDetail>
      </FinancialTableWrapper>
    </>
  );
}

export default UserFinancialPersonalDetailComponent;
